import AuthMixin from '@/components/mixins/auth-mixin'
import { useMixpanel } from '@base-shared/composables/use-mixpanel'
import { useUserStore } from '@base-shared/stores/user'

export default {
  name: 'accountSwitchedPage',
  inject: [
    '$currentUser',
    '$utils',
    '$signedInUserDetails',
    '$signedInUserAccounts'
  ],
  components: {
  },
  props: {
  },
  watch: {
    /**
     * Watches the `userStore.currentUser` for changes. Replacement
     * for the old `BIND_USER_DETAILS_IN_VUE` from EventBus.
     */
    'userStore.currentUser': {
      handler (newValue) {
        this.setDefaultData()
      },
      deep: true
    },
    /**
     * Watches the `userStore.accounts` for changes. Replacement
     * for the old `BIND_USER_ACCOUNTS_IN_VUE` from EventBus.
     */
    'userStore.accounts': {
      handler (newValue) {
        this.setDefaultData()
      },
      deep: true
    }
  },
  mixins: [AuthMixin],
  data () {
    return {
      accountOptions: [],
      currentAccountName: null
    }
  },
  setup () {
    // Expose the user store to the Options API context.
    return { userStore: useUserStore() };
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('default-layout-change', { action, payload: { data } })
      }
    },
    getAccountNameFromOptions (groupId) {
      let resAccountName = ''
      const getAccountName = this.accountOptions.find((acc) => { return acc.groupId === groupId })

      if (getAccountName) {
        resAccountName = getAccountName.name
      }

      return resAccountName
    },
    setDefaultData () {
      const currentUserGroupId = this.$currentUser.getUserGroupId() ?? null

      if (this.$signedInUserAccounts && this.$signedInUserAccounts.length) {
        this.showUserAccountDropdown = true
        this.accountOptions = this.$signedInUserAccounts
        this.currentAccountName = this.getAccountNameFromOptions(currentUserGroupId)
      }
    },
    handleAccountNameHover ($event, type) {
      const targetEl = $($($event.target).parent())
      const textEl = $($($event.target).parent()).find('.text')
      let showTooltip = textEl.length && (textEl[0].offsetWidth < textEl[0].scrollWidth)

      if (type === 'mouseover' && showTooltip) {
        showTooltip = true
      } else {
        showTooltip = false
      }

      this.$utils.handleCustomTooltip({ targetEl, showTooltip, fullText: textEl.text() })
    },
    handleContinueClick () {
      if (this.$utils.isPageForLicenses()) {
        this.$router.push('/')
      } else {
        this.$router.push('/menu')
      }
    }
  },
  mounted () {
    useMixpanel().track('Account Switched')

    this.isAuthenticated({
      callback: () => {
        this.setDefaultData()
      }
    })
  }
}
